import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { LegionellaVisitDetail } from 'src/app/models/legionella.model';

@Component({
  selector: 'app-legionella-visit',
  templateUrl: './legionella-visit.component.html',
  styleUrls: ['./legionella-visit.component.scss']
})
export class LegionellaVisitComponent implements OnInit {

  public visit!: LegionellaVisitDetail;

  constructor(private route: ActivatedRoute) { }

  ngOnInit(): void {
    this.route.data.subscribe((data) => {
      this.visit = data.visit;
    });
  }

  imageUrl(img: string) {
    // NOTE: these are actually linked via nginx to the shared folder...
    return '/assets/images/legionella/' + this.visit.id + '/' + img;
  }

}
